var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"share-button",attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.share()}}},[_vm._v("Share "),_c('font-awesome-icon',{attrs:{"icon":"share-alt"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }